import { render, staticRenderFns } from "./babyMutipul.vue?vue&type=template&id=3ce34c4f&scoped=true&"
import script from "./babyMutipul.vue?vue&type=script&lang=js&"
export * from "./babyMutipul.vue?vue&type=script&lang=js&"
import style0 from "./babyMutipul.vue?vue&type=style&index=0&id=3ce34c4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce34c4f",
  null
  
)

export default component.exports